export type DualListSide = 'include' | 'exclude';

export const DUAL_LIST_SIDES: DualListSide[] = ['include', 'exclude'];

export const SIDE_COLOR: Record<DualListSide, string> = {
    include: 'badge.green.fg',
    exclude: 'badge.red.fg',
};
